import { render, staticRenderFns } from "./FridgeNavigation.vue?vue&type=template&id=15f5ecbc&scoped=true&"
var script = {}
import style0 from "./FridgeNavigation.vue?vue&type=style&index=0&id=15f5ecbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f5ecbc",
  null
  
)

component.options.__file = "FridgeNavigation.vue"
export default component.exports